import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    mainConsentContent:{},
    marketingConsentContent:{},
    errorGetConsents : ''
}

const getConsentsReducer =(state = initialState,action)=>{
    switch(action.type.type){
            case actionTypes.GET_CONSENTS_SUCCESS:

            const mainConsent = action.type.response.find(r => r.type === "MAIN_CONSENT" );
            const marketingConsent = action.type.response.find(r => r.type === "MARKETING_CONSENT" );
        
            const mainConsentContent = {
                header:mainConsent.consentConfiguration.find(r => r.key === "HEADER" ),
                checkboxAgree:mainConsent.consentConfiguration.find(r => r.key === "CHECKBOX_AGREE" ),
                checkboxAgreeText:mainConsent.consentConfiguration.find(r => r.key === "CHECKBOX_AGREE_TEXT" ),
            }

            const marketingConsentContent = {
                checkboxAgree:marketingConsent.consentConfiguration.find(r => r.key === "CHECKBOX_AGREE"),
                checkboxDisagree:marketingConsent.consentConfiguration.find(r => r.key === "CHECKBOX_DISAGREE"),
            }
               
                return updateObject(state, {
                    mainConsentContent :mainConsentContent,
                    marketingConsentContent:marketingConsentContent
                })
            case actionTypes.GET_CONSENTS_FAILED:
                return updateObject(state, {
                    errorGetConsents:action.type.error.msg
                })
            default:{
                return state;
            }
        }
}

export default getConsentsReducer;